import {Fragment, useCallback, useEffect, useRef, useState} from 'react';

import Row from 'topmeteo/general/components/Row';
import Column from 'topmeteo/general/components/Column';
import EventListener, {withOptions} from 'topmeteo/general/components/EventListener';

import Matrix from './Matrix';
import Info from './Info';

/**
 * This component hides the matrix on mobile to improve the performance.
 */
const MatrixRow = ({type}) => {
    const rowRef = useRef(null);
    const [isVisible, setIsVisible] = useState(true);

    const handleResize = useCallback(
        () => {
            const style = window.getComputedStyle(rowRef.current);
            const isHidden = style.display === 'none';

            return setIsVisible(isHidden === false);
        },
        [rowRef, setIsVisible],
    );

    const onResize = withOptions(handleResize, {passive: true});

    useEffect(handleResize, [rowRef]); /* calculate this once on mount */

    return (
        <EventListener target={window} onResize={onResize}>
            <Row className="ctl-mtx" rowRef={rowRef}>
                {isVisible && (
                    <Fragment>
                        <Column size={9} className="ctl-mtx-panel">
                            <Matrix />
                        </Column>
                        <Info type={type} />
                    </Fragment>
                )}
            </Row>
        </EventListener>
    );
};

export default MatrixRow;
